const words = (value) =>
  (value || "").toLowerCase().match(/[\p{L}\p{N}]+/gu) || [];
const COMMON =
  "the and for with from your this that these those when what how use using saved agent skill skills brand source knowledge assist";

// These are discovery aids, not provenance. Only the collector's explicit
// parentSkill/path relationship is described as a saved skill connection.
export function relatedSources(entry, entries, workspaceName = "") {
  const excluded = new Set(words(`${COMMON} ${workspaceName}`));
  const terms = [...new Set(words(entry.title))].filter(
    (word) => word.length > 2 && !excluded.has(word),
  );
  const frequency = new Map();
  for (const row of entries) {
    for (const term of new Set(words(`${row.title} ${row.summary}`))) {
      frequency.set(term, (frequency.get(term) || 0) + 1);
    }
  }
  const skillName = (row) =>
    row.kind === "skill" ? row.sourcePath?.split("/").at(-2) : null;
  return entries
    .filter((row) => row.id !== entry.id)
    .map((row) => {
      const linked =
        (entry.parentSkill && entry.parentSkill === skillName(row)) ||
        (row.parentSkill && row.parentSkill === skillName(entry));
      const haystack = new Set(
        words(`${row.title} ${row.summary} ${row.content || ""}`),
      );
      const matched = terms.filter((term) => haystack.has(term));
      // Exclude ubiquitous words. Workspace names are filtered separately.
      const distinctive = matched.filter(
        (term) =>
          (frequency.get(term) || 0) <= Math.max(3, entries.length * 0.25),
      );
      const titleWords = new Set(words(row.title));
      const summaryWords = new Set(words(row.summary));
      const score = linked
        ? 100
        : distinctive.reduce(
            (sum, term) =>
              sum + (titleWords.has(term) ? 5 : summaryWords.has(term) ? 2 : 1),
            0,
          );
      return { entry: row, linked: Boolean(linked), terms: distinctive, score };
    })
    .filter((row) => row.score > 0)
    .sort(
      (a, b) => b.score - a.score || a.entry.title.localeCompare(b.entry.title),
    )
    .slice(0, 3);
}
